/* unplugin-vue-components disabled */import script from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__